import { render } from "./NoItems.vue?vue&type=template&id=f2c4f14e&scoped=true"
import script from "./NoItems.vue?vue&type=script&lang=js"
export * from "./NoItems.vue?vue&type=script&lang=js"

import "./NoItems.vue?vue&type=style&index=0&id=f2c4f14e&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2c4f14e"]])

export default __exports__